module.exports = __webpack_public_path__ + "static/media/watch&earn-popup-icon.44f1d364.png";